import React, { useState, useEffect } from 'react';
import { useSelector} from "react-redux";
import { useNavigate } from 'react-router-dom';

import { fetchVulnerabilityDetails as getThreatActorRegionService} from 'services/modules/ecs/data';

import { ScrollContainer } from "react-nice-scroll";
import { ListGroup,Card} from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const ThreatActorByRegion = () => {
  // use navigate hook
  const navigate = useNavigate();
  
  // State variables
  const [criticalThreats, setCriticalThreats] = useState([]);
  
  // Redux selectors
  const selectedCompany = useSelector((state) => state.auth.companyData );

  // Fetches Threat actors based on domain 
  useEffect(() => {
    const fetchThreatActors = async () => {
      setCriticalThreats([]);
      const params = { domain: selectedCompany?.domain };
      let response = await getThreatActorRegionService(params);
      const threatsWithVisibility = response?.map(threat => ({ ...threat, showActors: false }))||[];
      setCriticalThreats(threatsWithVisibility);
    }
    if (selectedCompany?.domain !== null) {
      fetchThreatActors();
    }
  }, [selectedCompany]);
  
  // Toggles Threat actor names by clciking on the alert description
  const toggleActorNames = (index) => {
    setCriticalThreats(prevThreats =>
      prevThreats?.map((threat, i) =>
        i === index ? { ...threat, showActors: !threat.showActors } : threat
      )
    );
  };
  
  // Handles navigation to single threat actor page
  const viewThreat = (actor) => {
    navigate(`/tip/threat?threat=${actor}`)
  }

  return (
    <div>
      <ScrollContainer className="topalerts-tip">
        <Card className="text-white rounded-10 topalerts-tip">
          <Card.Body>
            <Card.Title>
              <div className="carousel-title text-white">Threat Actors</div>
            </Card.Title>
            <Card.Text>
              <div className='topalerts-div'>
                <div>
                  {(!criticalThreats || criticalThreats?.length === 0) ? (
                    <span className="text-h8 text-center text-tertiary">
                      No findings found
                    </span>
                  ) : null}
                  {(criticalThreats && criticalThreats?.length > 0) ? (
                    <ListGroup className='topalerts-listgroup'>
                      {criticalThreats?.map((threat, index) => (
                          <ListGroup.Item action key ={index} onClick={() => toggleActorNames(index)} className="no-hover">
                            <div className="d-flex justify-content-between">
                              <span>{threat?.title}</span>
                              <ExpandMoreIcon  onClick={(e) => {
                                e.stopPropagation(); 
                                toggleActorNames(index);
                              }}/>
                            </div>
                            {threat?.showActors && (
                              <>
                                  {threat?.actor_names?.map((actor, i) => (
                                       <ListGroup.Item action key={i} style={{ cursor: 'pointer' }}
                                       onClick={(e) => {e.stopPropagation();viewThreat(actor)}}
                                       >
                                        <div>
                                        {actor}
                                        </div>
                                      </ListGroup.Item>
                                  ))}
                              </>
                            )}
                          </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : (
                    <div className="mt-3">
                      <hr className="my-2" />
                    </div>
                  )}
                </div>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </ScrollContainer>
    </div>
  );
}

export default ThreatActorByRegion;
